import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

import {
  adminRedirectTarget,
  kitchenSinkRedirectTarget,
} from './backoffice-redirect-urls'
import { resolveBackofficeUrl } from '@/lib/backoffice-url'

/**
 * Parity with next.config.js redirects: /admin and /admin/* → backoffice /explore.
 */
export function AdminToBackofficeRedirect() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const target = adminRedirectTarget(pathname, resolveBackofficeUrl())
    window.location.replace(target)
  }, [pathname])

  return null
}

/**
 * Parity with next.config.js: /internal/kitchen-sink* → backoffice explore kitchen-sink.
 */
export function KitchenSinkToBackofficeRedirect() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    const target = kitchenSinkRedirectTarget(pathname, resolveBackofficeUrl())
    window.location.replace(target)
  }, [pathname])

  return null
}
